"use client"

import { Button, Layout, Modal } from "antd"
import Typography from "antd/es/typography/Typography"
import { useEffect, useState } from "react"
import styles from "./styles.module.css"

const { Content } = Layout

type Produto = {
  nome: string
  descricao: string
  imagem: string
  lamina?: string
}

const categorias = [
  {
    titulo: "Churrasqueiras",
    produtos: [
      {
        nome: "Churrasqueia Bege",
        descricao: "Churrasqueia Bege",
        imagem: "/produtos/churras/CHURRASQUEIRA-AMARELA.webp",
        lamina: "/laminas/churras/CATALOGO.webp",
      },
      {
        nome: "Churrasqueia Vermelha",
        descricao: "Churrasqueia Vermelha",
        imagem: "/produtos/churras/CHURRASQUEIRA-VERMELHA.webp",
        lamina: "/laminas/churras/CATALOGO.webp",
      },
      {
        nome: "Churrasqueia Natural",
        descricao: "Churrasqueia Natural",
        imagem: "/produtos/churras/CHURRASQUEIRA-NATURAL.webp",
        lamina: "/laminas/churras/CATALOGO.webp",
      },
    ],
  },
]

export default function ChurrasqueirasPage() {
  const [modalVisible, setModalVisible] = useState(false)
  const [imagemModal, setImagemModal] = useState("")
  const [nomeProduto, setProdutoNome] = useState("")
  const [isMobile, setIsMobile] = useState(false)
  const [modalWidth, setModalWidth] = useState("50%")

  // Função para abrir o modal com a imagem
  const handleOpenModal = (imagem: string | undefined, nome: string) => {
    setImagemModal("") // Limpa a imagem anterior
    setTimeout(() => {
      if (imagem) setImagemModal(imagem)
      setProdutoNome(nome)
      setModalVisible(true)
    }, 100)
  }

  const handleCloseModal = () => {
    setModalVisible(false)
  }

  const handleDownload = () => {
    if (!imagemModal) return // Evita erro caso não tenha imagem carregada
    const link = document.createElement("a")
    link.href = imagemModal
    link.download = imagemModal.split("/").pop() || "imagem.png" // Nome do arquivo é o nome da imagem
    link.click()
  }

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768
      setIsMobile(mobile)
      setModalWidth(mobile ? "99%" : "50%")
    }

    window.addEventListener("resize", handleResize)
    handleResize() // Call once to set initial width

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <Layout>
      <Content className={styles.content}>
        <div className={styles.container}>
          {categorias.map((categoria, index) => (
            <div key={index} className={styles.categoria}>
              <h2 className={styles.categoriaTitulo}>{categoria.titulo}</h2>

              <div className={styles.produtosContainer}>
                {categoria.produtos.map((produto: Produto, i) => (
                  <div key={i} className={styles.produtoItem}>
                    <div className={styles.produtoImagemContainer}>
                      <img
                        alt={produto.nome}
                        src={produto.imagem || "/placeholder.svg"}
                        className={styles.produtoImagem}
                      />
                    </div>
                    <h3 className={styles.produtoTitulo}>{produto.nome}</h3>
                    <Button
                      type="primary"
                      className={styles.botaoSaibaMais}
                      onClick={() => handleOpenModal(produto.lamina, produto.nome)}
                    >
                      SAIBA MAIS
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Content>

      <Modal
        open={modalVisible}
        footer={null} // Remover footer para não sobrepor o botão
        onCancel={handleCloseModal}
        width="90%"
        style={{ maxWidth: modalWidth }} // Usando o valor de modalWidth
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              key="download"
              onClick={handleDownload}
              style={{ width: "150px", marginBottom: "10px" }} // Tamanho fixo de 150px
            >
              Baixar Imagem
            </Button>
            <Typography style={{ marginLeft: "20px", marginBottom: "10px", fontSize: "20px" }}>
              {nomeProduto}
            </Typography>
          </div>
        }
      >
        <img src={imagemModal || "/placeholder.svg"} alt="Lâmina" className={styles.imagemModal} />
      </Modal>
    </Layout>
  )
}
